export const weatherAbbreviations: { [key: string]: string } = {
	BC: 'Patches',
	BL: 'Blowing',
	BR: 'Mist',
	DR: 'Low Drifting',
	DS: 'Dust Storm',
	DU: 'Widespread Dust',
	DZ: 'Drizzle',
	FG: 'Fog',
	FC: 'Funnel Cloud',
	FU: 'Smoke',
	FZ: 'Freezing',
	GR: 'Hail',
	GS: 'Small Hail',
	HZ: 'Haze',
	IC: 'Ice Crystals',
	MI: 'Shallow',
	PL: 'Ice Pallets',
	PO: 'Dust Devils',
	RA: 'Rain',
	SA: 'Sand',
	SG: 'Snow Grains',
	SH: 'Shower',
	SN: 'Snow',
	SQ: 'Squall',
	SS: 'Sandstorm',
	TS: 'Thunderstorm',
	VA: 'Volcanic Ash',
	VC: 'In the vicinity',
	UP: 'Unidentified Precipitation',
	RE: 'Recent',
};

export const cloudAbbreviations: { [key: string]: string } = {
	SKC: 'Sky clear',
	NCD: 'Nil Cloud Detected',
	CLR: 'No Clouds Below 12.000 ft',
	NSC: 'No (nil) significant cloud',
	FEW: 'Few',
	SCT: 'Scattered',
	BKN: 'Broken',
	OVC: 'Overcast',
};

export const changeAbbrevitations: { [key: string]: string } = {
	U: 'Upgoing',
	D: 'Downgoing',
	N: 'No distinct tendency',
};